import { Dialog, DialogContent } from "@components/shadcn-ui/dialog"; // Adjust imports if necessary
import { Button } from "@components/shadcn-ui/button"; // Adjust the import path if needed

interface FilePreviewProps {
  closeModal: any;
  showImageModal: boolean;
  setShowImageModal: (show: boolean) => void;
  modalImage: string | null;
}

export const FilePreview = ({
  closeModal,
  showImageModal,
  setShowImageModal,
  modalImage,
}: FilePreviewProps) => {
  if (!modalImage) {
    return null;
  }

  return (
    <Dialog open={showImageModal} onOpenChange={setShowImageModal}>
      <DialogContent>
        <div className="flex justify-center mt-4 gap-2 items-center border-2 max-h-96">
          <img
            src={modalImage}
            alt="Preview"
            className="max-w-full h-full object-contain"
          />
        </div>
        <Button onClick={closeModal} className="mt-4">
          Close
        </Button>
      </DialogContent>
    </Dialog>
  );
};
